import axios from './axiosConfig';

//const API_URL = "https://api.demo2.raborisk.ai";
const API_URL = process.env.NODE_ENV === 'production' 
    ? "https://api.demo2.raborisk.ai" 
    : "http://localhost:3000";

//&& rm build/static/js/*.map


export const getRiskDashboardData = (risk_id) => {
    return (dispatch) => {
        axios.get(API_URL + "/api/dashboard/get_risk_dashboard_data/" + risk_id)
            .then(({ data }) => {
                dispatch({ type: "RISK_DASHBOARD_DATA", risk_dashboard_data: data });
            });
    };
};

export const getDepartmentDashboardData = (department_id) => {
    return (dispatch) => {
        axios.get(API_URL + "/api/dashboard/get_department_dashboard_data/" + department_id)
            .then(({ data }) => {
                ////console.log('API Response:', data);
                dispatch({ type: "DEPARTMENT_DASHBOARD_DATA", department_dashboard_data: data });
            });
    };
};

export const getComplianceDashboardData = (compliance_id) => {
    return (dispatch) => {
        axios.get(API_URL + "/api/dashboard/get_compliance_dashboard_data/" + compliance_id)
            .then(({ data }) => {
                //console.log('API Response:', data);
                dispatch({ type: "COMPLIANCE_DASHBOARD_DATA", compliance_dashboard_data: data });
            });
    };
};

export const getGeneralDashboardData = () => {
    return (dispatch) => {
        axios.get(API_URL + "/api/dashboard/get_general_dashboard_data")
            .then(({ data }) => {
                dispatch({ type: "GENERAL_DASHBOARD_DATA", general_dashboard_data: data });
            });
    };
};

export const getMetrics = (mode, department_id, risk_id) => {
    //console.log("Mode", mode, "department_id", department_id, "risk_id", risk_id)
    return (dispatch) => {
        axios.get(API_URL + "/api/dashboard/get_metrics/" + mode + "/" + department_id + "/" + risk_id)
            .then(({ data }) => {
                dispatch({ type: "METRICS", metrics: data });
            });
    };
};

export const getComplianceMetrics = (complience_id) => {
    console.log("compliance_id in call", complience_id)
    return (dispatch) => {
        axios.get(API_URL + "/api/dashboard/get_compliance_metrics/" + complience_id)
            .then(({ data }) => {
                dispatch({ type: "COMPLIANCE_METRICS", metrics: data });
            });
    };
};